import {
  useEventSettings,
  useLastIncident,
  useTeamSides,
} from '../../composables'
import { injectIncidentsTeamPossessionConfig } from '../provide-inject'

export function useIncidentsTeamPossession(): {
  isLastIncidentDefaultPossession: () => boolean
  isLastIncidentTeamInPossession: () => boolean
} {
  // inject
  const incidentsTeamPossessionConfig = injectIncidentsTeamPossessionConfig()

  // composables
  const { lastNonDeletedIncident, lastNonDeletedIncidentWithPosition } =
    useLastIncident()
  const { getIncidentTeamSide } = useTeamSides()
  const { eventSettings } = useEventSettings()

  // methods
  function isLastIncidentDefaultPossession(): boolean {
    if (!lastNonDeletedIncident.value) {
      return false
    }

    return (
      incidentsTeamPossessionConfig?.defaultPossessionIncidents?.has(
        lastNonDeletedIncident.value.incident_id,
      ) ?? false
    )
  }

  function isLastIncidentTeamInPossession(): boolean {
    if (!lastNonDeletedIncidentWithPosition.value) {
      return false
    }

    if (!eventSettings.value.teamSidePossession) {
      return false
    }

    let teamSidePossession = eventSettings.value.teamSidePossession
    if (
      incidentsTeamPossessionConfig?.swapPossessionIncidents?.has(
        lastNonDeletedIncidentWithPosition.value.incident_id,
      ) ??
      false
    ) {
      if (teamSidePossession === 'home') teamSidePossession = 'away'
      else if (teamSidePossession === 'away') teamSidePossession = 'home'
    }

    return (
      getIncidentTeamSide(lastNonDeletedIncidentWithPosition.value) ===
      teamSidePossession
    )
  }

  return { isLastIncidentDefaultPossession, isLastIncidentTeamInPossession }
}
